import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { router } from "router/index";
import { store } from "store";
import { Provider } from "react-redux";
import { ConfigProvider } from "antd";
import "./i18n";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <ConfigProvider
      theme={{
        token: {
          // fontSize: "16px",
          fontFamily: "Noto Sans CJK TC,sans-serif",
        },
        components: {
          Button: {
            fontSize: 16,
            borderRadius: 6,
            controlHeight: 36,
          },
          Input: {
            padding: 16,
            fontSize: 16,
          },
        },
      }}
    >
      <Provider store={store}>
        <RouterProvider router={router} />
      </Provider>
    </ConfigProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
